import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EventService } from 'app/modules/events/services/event.service';
import { SettingsService } from 'app/modules/settings/settings.service';
import { Country } from 'app/modules/shared/models/country';
import { ConfigService } from 'app/modules/shared/services/config.service';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import { filter, takeWhile } from 'rxjs/operators';
import { AppSettings } from '../../../app.settings';
import { CommonBindingDataService } from '../../../services/common-binding-data.service';
import { MessageService } from '../../../services/message.service';

@Component({
  selector: 'app-mi-select',
  templateUrl: './mi-select.component.html',
  styleUrls: ['./mi-select.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, DropdownModule, MultiSelectModule, CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MiSelectComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild('miSelect') miSelect!: MultiSelect;
  @ViewChild('dropdown') dropdown!: Dropdown;
  @Input() field: any;
  @Input() timeZones: any;
  formName: FormGroup;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  @Input() multiSelectDisplay: string = 'comma';
  alive = true;
  placeholder: any;
  filterIcon = 'pi pi-search';
  entityData: any = {
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT_FOR_SETTINGS,
    offset: 0,
    searchStr: "",
    defaultSortColumn: 'updatedAt',
    defaultSortType: 'desc',
    forTenantCode: this.configService.getForTenantCode(),
    attributeCode: AppSettings.ATTRIBUTE_CODE_FOR_SETTINGS.COLOR
  };
  country: Country;
  locationAttributeData;
  attributeIdForLocation;
  data;
  pickupPresetValues;
  dropPresetValues;
  pickLocationValues: any[] = [];
  dropLocationValues;
  vehicleTypes: any;
  bodyTypes: any;
  bodyTypePayload: any = {
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT_FOR_SETTINGS,
    offset: 0,
    searchStr: "",
    defaultSortColumn: 'updatedAt',
    defaultSortType: 'desc',
    forTenantCode: this.configService.getForTenantCode(),
    attributeCode: 'body_type'
  };

  constructor(
    private messageService: MessageService,
    private formGroupDirective: FormGroupDirective,
    public cs: CommonBindingDataService,
    private entityService: EntityService,
    private eventService: EventService,
    private settingsService: SettingsService,
    private configService: ConfigService,
    private cd: ChangeDetectorRef,
    private metaDataService: MetaDataService) {
    this.formName = this.formGroupDirective.control;
  }

  ngOnInit() {
    if (this.field.presetValues && Array.isArray(this.field.presetValues)) {
      this.field.presetValues.sort((a, b) => {
        const labelA = a.labelValue;
        const labelB = b.labelValue;
        return labelA.toString().localeCompare(labelB.toString());
      });
    }

    if (this.field.attributeCode === 'sorting') {
      this.formName.controls[this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode].setValue('Nearby');
    }

    if (this.field.attributeCode === 'shift_status') {
      this.formName.controls[this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode].setValue('On');
    }

    if (this.field.attributeCode === 'language') {
      this.formName.controls[this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode].setValue('English');
    }
    if (this.field.attributeCode === 'user_parent') {
      this.placeholder = this.cs.getLabelValue(`${this.moduleName}.fields.protocol_user_type.placeholder`, this.attributeLabels, null);
    } else {
      this.placeholder = this.cs.getLabelValue(`${this.moduleName}.fields.${this.field.attributeCode}.placeholder`, this.attributeLabels, null);
    }
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
  }

  ngAfterViewInit(): void {
    this.listenForLinkData();
  }


  listenForLinkData() {
    if (!this.field?.link) {
      return;
    }
    this.messageService.message$.pipe(
      filter(v => v.link === this.field.link),
      takeWhile(() => this.alive)
    ).subscribe((v) => {
      this.field.options = v.data
    })
  }

  clearSelectedDispatchZone() {
    this.formName.controls[this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode].setValue(null);
    setTimeout(() => {
      this.dropdown?.hide();
    }, 0);
  }

  changedValue(value: string) {
    if (this.field.attributeCode === 'rejection_reason_type') {
      const shouldShowReturnReason = value === 'OTHER';
      this.metaDataService.returnReasonVisibilitySubject.next(shouldShowReturnReason);
    }
    if (!this.field.provideData) {
      return;
    }
    this.messageService.messageSubject.next({
      link: this.field.attributeCode,
      data: this.field.provideData.filter(v => v.sourceValue === value)
    })
  }

  changedSelectedValue(value) {
    this.cs.sendDataToEntitySelect(value);
  }

  changedpMultiValue(value) {
    if (this.field.attributeCode === AppSettings.PASSENGER_PRIVILEGE_SETTINGS_SHOW_LIST_OF_PREDEFINED_LOCATIONS_ATTRIBUTE_CODE) {
      this.formName.controls[this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : AppSettings.PASSENGER_PRIVILEGE_SETTINGS_SELECTED_LOCATIONS_ATTRIBUTE_CODE].setValue(value.join(', '));
    }
  }

  onFilter(event) {
    if (event.filter) {
      this.filterIcon = 'pi pi-times'
    } else {
      this.filterIcon = 'pi pi-search';
    }
  }

  onFilterIconClick() {
    if (this.filterIcon.includes('times')) {
      this.miSelect.filterValue = null;
      this.filterIcon = 'pi pi-search';
    }
  }

  changedMultiValue() {
  }





  ngOnDestroy() {
    this.alive = false;
  }
}

